export interface GetPersonnelListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetPersonnelListPagingAndFilterResponseData
}

export interface GetPersonnelListPagingAndFilterResponseData {
    items: GetPersonnelListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetPersonnelListPagingAndFilterResponseItem {
    personnelId: string
    companyId: string
    nameSurname: string
    tckn: string
    phone: string
    email: string
    iban: string
    bankId: string
    currencyTypeId: string
    departmentId: string
    dutyId: string
    bankName: string
    currencyTypeName: string
    departmentName: string
    dutyName: string
    /** Bugün geçerli ücret; kayıt yoksa ya da "Personel Ücretleri" yetkisi yoksa null. */
    guncelAylikMaas?: number | null
    guncelSaatlikUcret?: number | null
    isCustomActive: boolean
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetPersonnelListPagingAndFilterResponseData: GetPersonnelListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}